const reportTypes = {
  clientSummaryReport: ['Client Summary Report'],
  clientSummaryReportOld: ['Client Summary Report (Old)'],
  completionReport: ['Completion Report'],
  drivetimeReport: ['Drive Time Report'],
  fcrReport: ['Complaint Report'],
  kpiReport: ['KPI Report'],
  onTimePerformanceReport: ['On Time Performance'],
  ratingsReport: ['Ratings Report'],
  vehicleReport: ['Vehicle Report'],
  punchReport: ['Punch Policy Report'],
  detailedReport: ['Detailed Report'],
  tripIssueReport: ['Trip Issue Report'],
  charityReport: ['Charity Report'],
  trainingReport: ['Training Report'],
};

export const hiddenReportTypes = {
  clientSummaryReportSnapshot: ['Client Summary Report Snapshot'],
};
export default reportTypes;
